import React, { useContext } from 'react';
import { IApkContext, ApkContext } from '../../../../apkState/apkContext';
import Text from 'components/Text/Text';
import Item from './components/Item';
import classNames from 'classnames';
import style from './List.module.scss';

const List: React.FC = () => {
	const { apk } = useContext<IApkContext>(ApkContext);

	const versionNameHeadingClasses = classNames(style.versionName, style.heading);
	const versionCodeHeadingClasses = classNames(style.versionCode, style.heading);
	const descriptionHeadingClasses = classNames(style.description, style.heading);
	const applicationIdHeadingClasses = classNames(style.applicationId, style.heading);
	const apkTypeHeadingClasses = classNames(style.apkType, style.heading);
	const actionHeadingClasses = classNames(style.action, style.heading);

	return (
		<div className={style.container} data-test="List">
			<div className={style.tableHeaders}>
				<Text
					className={versionNameHeadingClasses}
					translationNameSpace="listing"
					translationKey="versionNameLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={versionCodeHeadingClasses}
					translationNameSpace="listing"
					translationKey="versionCodeLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={descriptionHeadingClasses}
					translationNameSpace="listing"
					translationKey="descriptionLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={applicationIdHeadingClasses}
					translationNameSpace="listing"
					translationKey="applicationIdLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={apkTypeHeadingClasses}
					translationNameSpace="listing"
					translationKey="applicationApkTypeLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={actionHeadingClasses}
					translationNameSpace="listing"
					translationKey="actionLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			{apk.items.map((item, index) => (
				<Item data={item} key={item.id} index={index} />
			))}
		</div>
	);
};

export default List;
